exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\r\n/* .app-container {\r\n  padding: 20px;\r\n  background-color: #b0defd;\r\n} */\r\n\r\n/*\r\n.el-table th.el-table__cell>.cell.highlight{\r\n  color:#fecd07 !important;\r\n} */\n.item_icon[data-v-da1b1e3a] {\r\n          color: #67c23a;\r\n          font-size: 20px;\r\n          margin-left: 5px;\n}\r\n", ""]);

// exports
